import { useContext } from "react";
import { DateUtilsContext } from "../../core";
import { MaintenanceContext } from "./MaintenanceContext";

const dateTimeFormat = new Intl.DateTimeFormat("en", {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  timeZoneName: "short"
});

export function useGetMaintenancePeriod(){
  const { convertFromServerTime } = useContext(DateUtilsContext);
  const { from, to } = useContext(MaintenanceContext);
  

  return dateTimeFormat.formatRange(convertFromServerTime(from!)!, convertFromServerTime(to!)!)
}